export default "__VITE_ASSET__BBzrJui4__"